class Base64UploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }

    upload() {
        return this.loader.file.then(
            (file) =>
                new Promise((resolve, reject) => {
                    const reader = new FileReader();

                    reader.onload = () => {
                        resolve({ default: reader.result });
                    };

                    reader.onerror = (error) => {
                        reject(error);
                    };

                    reader.readAsDataURL(file);
                })
        );
    }

    abort() {
        // No-op: local file read cannot be cancelled reliably.
    }
}

export const registerBase64UploadAdapter = (editor) => {
    if (!editor?.plugins?.has?.("FileRepository")) return;

    editor.plugins.get("FileRepository").createUploadAdapter = (loader) =>
        new Base64UploadAdapter(loader);
};
